import React, {forwardRef} from 'react';

import {gettext} from 'topmeteo/utils/i18n';

import Error from './Error';
import Suggestions from './Suggestions';

const Title = gettext('Search');
const Placeholder = gettext('Location Search');

const StopPropagation = event => event.stopPropagation();

const LocationSearch = ({query, error, onErrorConfirm, onFocus, onChange, inputRef, ...props}) => (
    <div className="location-search">
        <input
            ref={inputRef}
            className="form-element"
            placeholder={Placeholder}
            title={Title}
            value={query}
            onFocus={onFocus}
            onChange={onChange}
            onClick={StopPropagation}
        />
        <Suggestions {...props} />
        {error && (
            <Error
                error={error}
                onErrorConfirm={onErrorConfirm}
            />
        )}
    </div>
);

export default forwardRef((props, ref) => <LocationSearch {...props} inputRef={ref} />);
